<template>
  <v-row
    class="flex-column recommended-job-item px-1 py-0"
    :class="job.JobInfo.Preferred ? 'preferredJob' : 'regJob'"
  >
    <v-col class="d-flex flex-column">
      <!-- header  -->
      <v-row class="pa-2 flex-nowrap" justify="space-between">
        <v-col class="job-name pl-1 pr-0 py-0" cols="10">
          <nuxt-link
            :target="'_self'"
            :to="`${job.JobInfo.Link}`"
            title="פתח משרה בחלון חדש"
            class="no-underline-all d-flex display-18"
            color="primary"
            :prefetch="false"
            @click.native="clickRecommendedJob()"
          >
            <div class="font-weight-medium">
              {{ job.JobContent.Name }}
            </div>
          </nuxt-link>
        </v-col>

        <!-- <v-spacer></v-spacer> -->
        <v-col cols="2" class="px-0 py-0" v-if="!$vuetify.breakpoint.xsOnly">
          <AddToFavorite
            v-if="!jobAllreadyApplied"
            class="mx-1 flex-center"
            :jobCode="job.JobInfo.JobCode"
            :isFavorite="isFavorite"
            :is-recommended-job="true"
            :disableOnMandatory="job.JobInfo.HasFilter"
            :jobIndex="jobIndex"
            :currentPage="currentPage"
            :job-name="job.JobContent.Name"
            :job-id="job.JobAnalytics.cd68"
            :job-position="job.JobAnalytics.cd69"
          />
        </v-col>
      </v-row>
      <!-- company  -->
      <v-row class="flex-nowrap">
        <v-col class="job-company py-0">
          <nuxt-link
            :target="'_self'"
            :to="`${job.JobInfo.Link}`"
            title="פתח משרה בחלון חדש"
            class="no-underline-all d-flex black--text text-wrap"
            :prefetch="false"
            @click.native="clickRecommendedJob()"
          >
            <div class="display-14 underline font-weight-medium">
              {{ job.Company.CompanyDisplayName }}
            </div>
          </nuxt-link>
        </v-col>
      </v-row>
      <!-- job details  -->
      <v-row class="flex-nowrap align-self-baseline" align="center">
        <!-- job Addresses -->
        <v-col class="py-1 delimiter">
          <div class="job-location display-details text-no-wrap">
            {{firstAddressCity}}
          </div>
        </v-col>

        <!-- job Experience -->
        <v-col class="py-1 delimiter">
          <div class="display-details text-no-wrap">
            {{ job.JobContent.Experience.NameInHebrew }}
          </div>
        </v-col>
        <!-- job scopes -->
        <v-col class="py-1">
          <div
            v-for="(scope, index) in job.JobContent.Scopes"
            :key="index"
            class="display-details region-item text-no-wrap d-inline"
          >
            <span top v-if="index === 0">{{ scope['NameInHebrew'] }}</span>

            <v-tooltip top v-if="index === 1">
              <template v-slot:activator="{ on }">
                <span
                  v-on="on"
                  text
                  class="display-details pointer-underline d-inline"
                >
                  ועוד
                </span>
              </template>
              <span
                class="display-details d-block text-no-wrap"
                v-for="(item, i) in job.JobContent.Scopes"
                :key="i"
              >
                <span v-if="i > 0">{{ item['NameInHebrew'] }}</span>
              </span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>

      <!-- job Description  -->
      <v-row class="flex-nowrap" v-if="displayJobDescription">
        <v-col class="job-description pt-2 pb-1">
          <nuxt-link
            :target="'_self'"
            :to="`${job.JobInfo.Link}`"
            title="פתח משרה בחלון חדש"
            :prefetch="false"
            @click.native="clickRecommendedJob()"
          >
            <div
              class="display-14-12 secondary--text"
              v-html="stripDescriptionTags(job.JobContent.Description)"
            ></div>
          </nuxt-link>
        </v-col>
      </v-row>

      <!-- button section -->
      <v-row class="flex-nowrap">
        <v-col v-if="$vuetify.breakpoint.xsOnly" cols="2">
          <AddToFavorite
            v-if="!jobAllreadyApplied"
            class="mx-1 flex-center"
            :jobCode="job.JobInfo.JobCode"
            :isFavorite="isFavorite"
            :is-recommended-job="true"
            :disableOnMandatory="job.JobInfo.HasFilter"
            :jobIndex="jobIndex"
            :currentPage="currentPage"
            :job-name="job.JobContent.Name"
            :job-id="job.JobAnalytics.cd68"
            :job-position="job.JobAnalytics.cd69"
          />
        </v-col>
        <v-col v-if="forwardToJobPage" class="text-left">
          <v-btn
            rounded
            :to="job.JobInfo.Link"
            color="success"
            class="text-left"
          >
            לעמוד המשרה
          </v-btn>
        </v-col>
        <v-col class="text-left" v-else>
          <CvButton
            :AllowNoCV="job.JobInfo.AllowNoCV"
            :ExternalLink="job.SendCVButtonModel.ExternalLink"
            :IsExpired="job.JobInfo.IsExpired"
            :FullName="job.JobContent.Name"
            :Code="job.Code"
            :job-code="job.JobInfo.JobCode"
            :job-analytics="job.JobAnalytics"
            :job-hash="job.JobInfo.Hash"
            :cv-link="job.SendCVButtonModel.ButtonLink"
            :job-to-link="job.Company.Job2Link"
            :cv-btn-txt="job.SendCVButtonModel.Text"
            :job-index="jobIndex"
            v-if="!jobAllreadyApplied"
            :currentPage="currentPage"
            :IsRecommender="true"
          />
          <span v-if="jobAllreadyApplied">קורות חיים נשלחו ב-</span>
          <span>{{ sendingDate() }}</span>
        </v-col>
      </v-row>
      <!-- jobAllreadyApplied {{ jobAllreadyApplied }} -->
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { DetectHTMLTagsPattern } from '@/lib/utils';
import AddToFavorite from '@/components/Jobs_List/Add_To_Favorite/AddToFavorite';
import gtm from '@/lib/gtm';
import CvButton from '@/components/Jobs_List/Cv_Button/CvButton';

export default {
  components: { AddToFavorite, CvButton },
  props: {
    currentPage: {
      type: String,
      required: false,
      default: '',
    },
    job: {
      type: Object,
      required: false,
      default: () => {},
    },
    jobIndex: {
      type: Number,
      required: false,
      default: 0,
    },
    userIsLogged: {
      type: Boolean,
      required: false,
      default: false,
    },
    forwardToJobPage: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayJobDescription: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayMoreJobsBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    firstAddressCity() {
      if (this.job.JobContent.Addresses?.length > 0) {
        return this.job.JobContent.Addresses[0].City;
      } else {
        return '';
      }
    },
    ...mapGetters(['checkIfJobIsLiked', 'checkIfAppliedForJob', 'sendCvDate']),
    isFavorite() {
      return this.checkIfJobIsLiked(this.job.Code);
    },
    jobAllreadyApplied() {
      return this.checkIfAppliedForJob(this.job.Code);
    },
  },
  mounted() {
    // fire gtm impression events
    this.fireGtmEvent();
  },
  methods: {
    /* Display sending Date instead of CV button */
    sendingDate() {
      if (this.userIsLogged && this.jobAllreadyApplied) {
        const sentDate = this.sendCvDate(this.job.Code)
          .substring(0, 10)
          .split('-')
          .reverse()
          .join('-');
        return sentDate;
      }
    },

    stripDescriptionTags(description) {
      let count = 110;

      if (this.$vuetify.breakpoint.xsOnly) {
        count = 80;
      }

      if (DetectHTMLTagsPattern.test(description)) {
        description = description.replace(DetectHTMLTagsPattern, '  ');
      }
      if (description?.length > count) {
        description = description.substring(0, count) + '...';
      }
      return description;
    },
    fireGtmEvent() {
      /** job impression event for each job  item on mounted */
      const dataLayer = {
        category: 'recommender',
        action: 'job impression',
        label: this.job.JobAnalytics.name, //job_name
        cd68: this.job.JobAnalytics.IDjob || this.job.JobAnalytics.id, //IDjob
        cd69: this.job.JobAnalytics.cd69, //position
        cd70: this.currentPage,
        event: 'drushim_recommender',
      };
      // gtm(_dataLayer);
      gtm(dataLayer);
    },
    clickRecommendedJob() {
      const dataLayerJobClick = {
        category: 'recommender',
        action: 'job click',
        label: this.job.JobAnalytics.name, //job_name
        cd68: this.job.JobAnalytics.cd68, //IDjob
        cd69: this.job.JobAnalytics.cd69, //position
        cd70: this.currentPage,
        event: 'drushim_recommender',
      };
      const dataLayerRecommenderClick = {
        category: 'recommender',
        action: 'recommender click',
        cd70: this.currentPage,
        event: 'drushim_recommender',
      };
      gtm(dataLayerJobClick);
      gtm(dataLayerRecommenderClick);
    },
  },
};
</script>

<style lang="sass" scoped>
// slider css 

.recommended-job-item.preferredJob
  box-shadow: 0px 1px 2px rgb(0 0 0 / 46%)
  border: 1px solid #eee
  border-right: 8px solid $primary
.recommended-job-item.regJob
  box-shadow: 0px 1px 2px rgb(0 0 0 / 46%)
  border: 1px solid #eee
  border-right: 8px solid #EFF0F2

.recommended-job-item.job-item-slider
  width: 290px
  min-width: 290px
  max-width: 290px
  // transform: scale(0.9)
  // min-width: 320px
  margin: 0 10px 0 15px

  @media only screen and (min-width: 600px)
    max-width: 500px
    min-width: 500px

// grid css grid
.recommended-job-item.job-item-carousel
  width: 320px
  min-width: 320px
  max-width: 320px
  // width: 100%
  margin: auto
  @media only screen and (min-width: 900px)
    width: 500px
    max-width: 500px
    margin: 0 15px
    min-height: 270px

// grid css grid
.recommended-job-item.job-item-grid
  min-height: 200px
  max-width: 440px
  // width: 100%
  @media only screen and (min-width: 900px)
    // width: 450px
    max-width: 440px
    margin: 0 0 0 15px
    min-height: 270px
    // max-height: 270px

.delimiter
  position: relative
  :after
    content: "|"
    position: absolute
    left: 0

.job-description
  border-top: 1px solid #eff0f2
.job-description, .job-name
  white-space: normal
.display-details
  font-size: 12px
  @media only screen and (min-width: 600px)
    font-size: 14px
</style>
